// src/assets/toastService.ts
import { Bounce, toast, Id, ToastOptions } from "react-toastify";

let loadingToastId: Id | null = null;

// Common toast options
const baseOptions: ToastOptions = {
  position: "top-right",
  hideProgressBar: false,
  closeOnClick: false,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  theme: "light",
  transition: Bounce,
};

// 🔵 Show loading toast (only one at a time)
export const notifyLoading = (message: string) => {
  if (loadingToastId) return; // prevent duplicates

  loadingToastId = toast.loading(message, {
    ...baseOptions,
    draggable: false, // better UX for loading
  });
};

// 🔵 Close loading toast manually
export const closeLoading = () => {
  if (loadingToastId) {
    toast.dismiss(loadingToastId);
    loadingToastId = null;
  }
};

// 🟢 Success toast
export const notifySuccess = (message: string) => {
  toast.success(message, {
    ...baseOptions,
    autoClose: 1800,
  });
};

// 🔴 Error toast
export const notifyError = (message: string) => {
  toast.error(message, {
    ...baseOptions,
    autoClose: 2000,
  });
};

// 🟡 Warning toast
export const notifyWarning = (message: string) => {
  toast.warning(message, {
    ...baseOptions,
    autoClose: 2000,
  });
};

// Info toast
export const notifyInfo = (message: string) => {
  toast.info(message, {
    ...baseOptions,
    autoClose: 2000,
  });
}
